import { render, staticRenderFns } from "./Podlazie.vue?vue&type=template&id=572b9bc5&scoped=true"
import script from "./Podlazie.vue?vue&type=script&lang=js"
export * from "./Podlazie.vue?vue&type=script&lang=js"
import style0 from "./Podlazie.vue?vue&type=style&index=0&id=572b9bc5&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572b9bc5",
  null
  
)

export default component.exports